<template>
    <div class="CommunityFamilyAssignment">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <h3>Link to Existing Community Family:</h3>
                        <v-select :options="CommunityFamilyOptions" label="text" :reduce="option => option.value" v-model="ExistingCommunityFamilyID"></v-select>
                        <b-button class="form-control" variant="success" @click="LinkToExisting()" v-if="ExistingCommunityFamilyID">
                            <i class="fa fa-link" /> LINK TO SELECTED FAMILY
                        </b-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h3 class="center-text" style="margin-top:20px;margin-bottom:20px;">-- OR --</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h3>Create/Link to NEW Community Family:</h3>
                        <p><i class="fa fa-exclamation red" /> Before creating a new Community Family record, please check the existing family list (above) to ensure that this family isn't already in our database systems.  This will help prevent duplicate records.</p>
                        <b-button class="form-control" variant="success" @click="OpenNewCommunityFamilyPreFill()">
                            <i class="fa fa-plus" /> CREATE NEW COMMUNITY FAMILY AND LINK
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="col">
                <h3>Inquiry Info:</h3>
                <p><span class="bold">Inquiry Date: </span>{{ formatDate(RecordData.InquiryDateTime,'MM/DD/YY') }}</p>
                <p><span class="bold">Inquiry Type: </span>{{ RecordData.InquiryType }}</p>
                <p><span class="bold">Parent Name(s): </span>{{ RecordData.InqParentNames }}</p>
                <p><span class="bold">DOB: </span>{{ formatDate(RecordData.InqDOB) }}</p>
                <p><span class="bold">Email: </span>{{ RecordData.InqEmail }}</p>
                <p><span class="bold">Phone: </span>{{ RecordData.InqPhoneNumber }}</p>
                <p><span class="bold">Address Line 1: </span>{{ RecordData.InqAddressLine1 }}</p>
                <p><span class="bold">Address Line 2: </span>{{ RecordData.InqAddressLine2 }}</p>
                <p><span class="bold">City: </span>{{ RecordData.InqCity }}</p>
                <p><span class="bold">State: </span>{{ RecordData.InqStateAbbreviation }}</p>
                <p><span class="bold">Zip: </span>{{ RecordData.InqZipCode }}</p>
                <p><span class="bold">Language: </span>{{ RecordData.InqPrimaryLanguageSpoken }}</p>
                <p><span class="bold">Number of Children Needing Assistance: </span>{{ RecordData.InqNumberOfChildrenWhoNeedAssistance }}</p>
                <p><span class="bold">Current Homelessness: </span>{{ RecordData.InqCurrentlyExperiencingHomelessness }}</p>
                <p><span class="bold">Urgency: </span>{{ RecordData.InqUrgencyOfAssistanceNeeded }}</p>
                <p><span class="bold">Referral Source: </span>{{ RecordData.InqReferralSource }}</p>
                <p><span class="bold">Comments: </span>{{ RecordData.InqReasonForAssistance }}</p>
            </div>
        </div>

        <NewCommunityFamily ref="component-add-record" @newprefilladded="OnNewPrefillAdded"/>
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    //import components
    import NewCommunityFamily from '../../CommunityFamilies/NewCommunityFamily.vue';
    import { EventBus } from '../../../../../services/event-bus.js';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                ExistingCommunityFamilyID: "",
                CommunityFamilyOptions: [],
                NewCommunityFamilyRecord: {},
                EditMode: false,

            };
        },
        methods: {
            //API
            GetCommunityFamilyOptions() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/CommunityFamilies/Options", { SubProgramID: this.RecordData.InqTerritory.SubProgramID }, this.GetCommunityFamilyOptionsSuccess, () => { }, true);
            },
            GetCommunityFamilyOptionsSuccess(response) {
                this.CommunityFamilyOptions = response.data.data;
            },
            LinkToExisting() {
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Referrals/LinkCommunityFamily", { CommunityFamilyID: this.ExistingCommunityFamilyID, CommunityFamilyReferralID: this.RecordData.Id }, this.LinkToExistingSuccess, () => { }, true);
            },
            LinkToExistingSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.RecordData.Id);
            },
            //UI
            OpenNewCommunityFamilyPreFill() {
                this.$refs['component-add-record'].ShowModalWithPreFillData(this.RecordData.InqParentNames, this.RecordData.InqAddressLine1, this.RecordData.InqAddressLine2, this.RecordData.InqCity, this.RecordData.InqStateAbbreviation, this.RecordData.InqZipCode, this.RecordData.InqTerritoryID, this.RecordData.InquiryDateTime, this.RecordData.Id)
            },
            OnNewPrefillAdded(newCommFamArgs) {
                //Create label
                let selectLabel = "JUST ADDED: " + newCommFamArgs.CommunityFamilyName + " (" + newCommFamArgs.CommunityFamilyTerritoryName + ", " + newCommFamArgs.CommunityFamilyCity + ")";
                //Add item to options and select it
                let newSelectItem = {
                    text: selectLabel,
                    value: newCommFamArgs.CommunityFamilyID
                };
                this.CommunityFamilyOptions.push(newSelectItem);
                this.ExistingCommunityFamilyID = newCommFamArgs.CommunityFamilyID;
                this.LinkToExisting();
                Alert("The new family you created has been linked to this Referral")
            },
            GlobalPaneChangeCommunityFamily() {
                this.$store.commit("CommunityFamilies.Profiles.Append", { Id: this.RecordData.CommunityFamilyID });
                EventBus.$emit('globalpanechange', this.RecordData.CommunityFamilyID);
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
        },
        components: {
            NewCommunityFamily,
            vSelect
        },
        mounted() {
            this.GetCommunityFamilyOptions();
            this.ExistingCommunityFamilyID = this.RecordData.CommunityFamilyID;
        },
        computed: {
            
        }
    }
</script>

<style scoped>

</style>